module.exports = __webpack_public_path__ + "img/subject-pic1.c510b0b9.png";